export enum IntegrationsTypeEnum {
    ThirdPartyDelivery = 'ThirdPartyDelivery',
}
